import FooterSection from "assets/Footer";
import Navbar from "assets/Navbar";
import { useEffect, useState } from "react";
import { BsCartXFill } from "react-icons/bs";
import { HiOutlineX } from "react-icons/hi";
import { TbCurrencyTaka } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import OrderShimmer from "../components/shimmer/orderShimmer";
import ScreenScrollToTop from "../components/ScreenScrollToTop";
import { getCartItems, setCartItems } from "utils/cartStorage";

const AddCartDetails = () => {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const storedItems = getCartItems();
      setProducts(storedItems);
      setLoading(false);
    }, 500);
  }, []);

  const updateLocalStorage = (items) => {
    setCartItems(items);
  };

  const increaseQuantity = (index) => {
    const updated = [...products];
    updated[index].quantity = (updated[index].quantity || 1) + 1;
    setProducts(updated);
    updateLocalStorage(updated);
  };

  const decreaseQuantity = (index) => {
    const updated = [...products];
    if ((updated[index].quantity || 1) > 1) {
      updated[index].quantity -= 1;
      setProducts(updated);
      updateLocalStorage(updated);
    }
  };

  const removeItem = (index) => {
    const updated = [...products];
    updated.splice(index, 1); // remove the item
    setProducts(updated);
    updateLocalStorage(updated);
  };

  const subtotal = products.reduce(
    (total, item) =>
      total + (item.selectedVariant?.flashPrice || 0) * (item.quantity || 1),
    0,
  );

  return (
    <div className="flex flex-col min-h-[100dvh]">
      <Navbar />
      <div className="flex-1 mb-3">
        {loading ? (
          <OrderShimmer />
        ) : products.length === 0 ? (
          <div className="flex flex-1 flex-col justify-center items-center text-center text-[#265fc9] py-10">
            <BsCartXFill className="mx-auto w-24 h-24 sm:w-40 sm:h-40 mb-5 opacity-60" />
            <h3 className="text-base sm:text-lg font-semibold mb-2 mt-5">
              কোনো পণ্য পাওয়া যায়নি
            </h3>
          </div>
        ) : (
          <>
            <div className="container mx-auto px-4 sm:px-5 mt-5">
              <div className="flex flex-col lg:flex-row gap-6">
                <div className="w-full lg:w-2/3">
                  <div className="bg-[#F5F5F5]  p-4">
                    {/* Desktop Header */}
                    <div className="hidden md:grid grid-cols-5 font-semibold border-b pb-2">
                      <div className="col-span-2">Product</div>
                      <div className="text-center">Price</div>
                      <div className="text-center">Quantity</div>
                      <div className="text-right">Total</div>
                    </div>

                    {products.map((item, index) => (
                      <div
                        key={index}
                        className="flex flex-col md:grid md:grid-cols-5 gap-3 md:gap-4 items-center border-b py-4"
                      >
                        {/* Product Info */}
                        <div className="flex gap-3 items-center col-span-2 w-full">
                          <img
                            src={`https://backend.nuhababy.com/${item.selectedVariant.images[0].thumb}`}
                            alt={item.selectedVariant?.title}
                            loading="lazy"
                            decoding="async"
                            className="w-16 h-16 sm:w-20 sm:h-20 object-top object-cover rounded"
                          />
                          <div className="flex-1">
                            <p className="font-medium text-sm sm:text-base hidden md:flex">
                              {item.selectedVariant?.title}
                            </p>
                            <p className="text-xs sm:text-sm text-gray-500 mt-1 md:hidden">
                              {item.selectedVariant?.title}
                            </p>
                            {/* <button
                            className="text-red-600 text-xs sm:text-sm mt-1 flex items-center"
                            onClick={() => removeItem(index)}
                          >
                            <HiOutlineX className="w-4 h-4 mr-1" />
                          </button> */}
                          </div>
                        </div>

                        {/* Price - Desktop */}
                        <div className="hidden md:flex justify-center items-center text-[#265fc9]">
                          <span className="font-medium lg:text-base text-sm">
                            {item.selectedVariant?.flashPrice}
                          </span>
                          <TbCurrencyTaka className="text-[#265fc9] font-bold" />
                        </div>

                        {/* Quantity Controls - Desktop */}
                        <div className="hidden md:flex items-center justify-center space-x-2">
                          <button
                            className="border-2 border-gray-300 w-8 h-8 flex items-center justify-center text-red-600 rounded disabled:opacity-50"
                            onClick={() => decreaseQuantity(index)}
                            disabled={(item.quantity || 1) <= 1}
                          >
                            -
                          </button>
                          <span className="w-8 text-center">
                            {item.quantity || 1}
                          </span>
                          <button
                            className="border-2 border-gray-300 w-8 h-8 flex items-center justify-center text-[#265fc9] rounded"
                            onClick={() => increaseQuantity(index)}
                          >
                            +
                          </button>
                        </div>

                        {/* Mobile View - Price and Quantity */}
                        <div className="md:hidden w-full mt-2">
                          <div className="flex justify-between items-center">
                            <div className="flex items-center">
                              <button
                                className="border-2 border-gray-300 w-8 h-8 flex items-center justify-center text-red-600 rounded disabled:opacity-50"
                                onClick={() => decreaseQuantity(index)}
                                disabled={(item.quantity || 1) <= 1}
                              >
                                -
                              </button>
                              <span className="w-8 text-center">
                                {item.quantity || 1}
                              </span>
                              <button
                                className="border-2 border-gray-300 w-8 h-8 flex items-center justify-center text-[#265fc9] rounded"
                                onClick={() => increaseQuantity(index)}
                              >
                                +
                              </button>
                            </div>
                            <div className="flex">
                              <div className=" flex font-medium items-center text-[#265fc9]">
                                {(
                                  (item.selectedVariant?.flashPrice || 0) *
                                  (item.quantity || 1)
                                ).toFixed(2)}
                                <TbCurrencyTaka />
                              </div>
                              <button
                                className="text-red-600 text-xs sm:text-sm mt-1"
                                onClick={() => removeItem(index)}
                              >
                                <HiOutlineX className="w-4 h-4 mr-1" />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Total - Desktop */}
                        <div className="flex items-center justify-end">
                          <div className="hidden md:flex justify-end font-medium items-center text-[#265fc9]">
                            {(
                              (item.selectedVariant?.flashPrice || 0) *
                              (item.quantity || 1)
                            ).toFixed(2)}
                            <TbCurrencyTaka />
                          </div>
                          <button
                            className="text-red-600 text-xs sm:text-sm mt-1 hidden md:flex"
                            onClick={() => removeItem(index)}
                          >
                            <HiOutlineX className="w-4 h-4 mr-1" />
                          </button>
                        </div>
                      </div>
                    ))}
                    {/* </> */}
                    {/* )} */}
                  </div>
                </div>
                <div className="w-full lg:w-1/3 mb-5">
                  <div className="bg-[#F5F5F5] border-4 border-gray-200 rounded-lg shadow-sm p-5 sticky top-4">
                    <h2 className="lg:text-xl md:text-lg text-base font-semibold mb-5">
                      CART
                    </h2>
                    <div className="space-y-5">
                      <div className="flex justify-between items-center">
                        <div className="md:text-sm text-xs font-semibold">
                          Delivery Charge
                        </div>
                        <div className="md:text-sm text-xs text-right">
                          <p className="py-1">
                            ঢাকার ভিতর:{" "}
                            <span className="text-[#265fc9]">70.00 ৳</span>
                          </p>
                          <p className="py-1">
                            ঢাকার বাহিরে:{" "}
                            <span className="text-[#265fc9]">130.00 ৳</span>
                          </p>
                          <p className="py-1">
                            দোকান থেকে সংগ্রহ:{" "}
                            <span className="text-[#265fc9]">00.00 ৳</span>
                          </p>
                        </div>
                      </div>
                      <div className="border-t pt-3 mt-3 font-semibold flex justify-between md:text-lg text-md">
                        <span>Total</span>
                        <span className="text-[#265fc9]">
                          {subtotal.toFixed(2)}
                          <TbCurrencyTaka className="inline" />
                        </span>
                      </div>
                    </div>
                    <button
                      onClick={() => navigate("/orderDetails")}
                      className="w-full bg-[#265fc9] text-white md:py-3 py-2 rounded-lg mt-4 transition-colors lg:text-base text-sm  font-semibold"
                    >
                      পরবর্তী ধাপ
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <FooterSection />
      <ScreenScrollToTop />
    </div>
  );
};

export default AddCartDetails;
